/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
  'embedded.confluence.already-logged-in-paragraph': 'Er du allerede logget på? Prøv å oppdatere.',
  'embedded.confluence.footer.hover.text': 'Vis i Confluence',
  'embedded.confluence.footer.prefix': 'Levert av',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Logg på Confluence',
  'embedded.confluence.login-page.login-button': 'Logg på Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Påloggingsknapp',
  'embedded.confluence.login-page.login-text': 'Du må være logget på for å se denne siden',
  'embedded.confluence.login-page.refresh-page-banner':
    'Etter pålogging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for å oppdatere',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
  'embedded.confluence.need-to-log-in-paragraph': 'Du må være logget på for å se denne siden',
  'embedded.confluence.still-having-trouble-paragraph':
    'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
  'embedded.confluence.troubleshooting-link-text': 'se denne feilsøkingsveiledningen.',
  'embedded.confluence.troubleshooting-link.aria-label': 'kobling til feilsøkingsveiledning',
};
